import { render } from "./footer.vue?vue&type=template&id=2cd86660&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=2cd86660&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2cd86660"

export default script